module.exports = __webpack_public_path__ + "img/66.8f602fd4.png";